import store from "~/js/store/store";
import _each from "lodash/each";
import lazySizes from "lazysizes";
import { focusVisiblePolyfill, handleDialogFocus, handleFirstTab } from "~/js/common/accessibility";

class Common {
  constructor() {}
  init() {
    const main = document.querySelector("main");
    if (main) {
      main.classList.add("loadcomplete");
      /*let _main = document.querySelector("#main");
      if (!_main) {
        main.id = "main";
      }*/
    }
    window.addEventListener("keydown", (event) => {
      store.dispatch("keydown", {
        code: event.code,
        target: event.target
      });
    });
    window.addEventListener("keyup", (event) => {
      store.dispatch("keyup", {
        code: event.code,
        target: event.target
      });
    });

    window.addEventListener("resize", () => {
      store.dispatch("windowResized", {
        width: window.innerWidth
      });
    });
    store.dispatch("updateDeviceType", {
      width: window.innerWidth
    });
    const imgs = document.querySelectorAll("img");
    _each(imgs, (img) => {
      img.addEventListener(
        "contextmenu",
        (e) => {
          e.stopPropagation();
          e.preventDefault();
          return false;
        },
        true
      );
    });
    this.setupHistoryback();

    this.checkAuthorization();
    focusVisiblePolyfill()
    handleDialogFocus()

    window.addEventListener('keydown', handleFirstTab)
  }

  isSPSize() {
    return window.innerWidth <= store.state.constant.spWidth;
  }

  isTabletSize() {
    return window.innerWidth <= store.state.constant.tabletWidth;
  }

  setupHistoryback() {
    let links = document.querySelectorAll(".js-historyback");
    _each(links, (link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        history.back();
      });
    });
  }

  setupScrollY(isPin = false) {
    window.addEventListener("scroll", (event) => {
      store.dispatch("scrollY", {
        y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop,
        isPin: isPin
      });
    });
  }

  // ページのオプション設定を行う
  setupPageOptions() {
    let _base = document.querySelector(".js-pageoptions");
    if (!_base) {
      return;
    }
    // Header Transparent
    let opt = _base.getAttribute("data-transparent-header");
    if (opt) {
      this.addHeaderTransparent();
    }
    // And More...
  }

  addHeaderTransparent() {
    document.body.classList.add("transparent-header");
  }

  addZero(num) {
    return ("0" + num).slice(-2);
  }

  addComma(num) {
    // 入力されたカンマを消去
    let wnum = new String(num).replace(/,/g, "");
    // 最上位桁まで下桁から３桁ごとにカンマ付加を繰り返す
    while (wnum != (wnum = wnum.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    return wnum;
  }

  addNoscrollAllChildren(parentNode, isOwn = false) {
    const allChildren = parentNode.children;
    if (isOwn) {
      parentNode.classList.add("js-noscroll");
    }
    _each(allChildren, (elm, index) => {
      this.addNoscroll(elm);
    });
  }

  addNoscroll(elm) {
    elm.classList.add("js-noscroll");
    this.addNoscrollAllChildren(elm);
  }

  removeNoscroll(elm) {
    if (elm.classList.contains("js-noscroll")) {
      elm.classList.remove("js-noscroll");
    }
  }

  /**
   * コンテンツ側のtabindexを有効・無効にする
   * @param activate
   */
  toggleTabIndexActivate(activate, useHeader = false) {
    let gotoContents = document.querySelectorAll(".js-gotocontents");
    let _anchors = document.querySelectorAll("main a");
    let _buttons = document.querySelectorAll("main button");
    let _breadcrumbs = document.querySelectorAll(".breadcrumb a");
    let _footers = document.querySelectorAll(".l-footer a, .l-footer input, .l-footer select");
    let _header = document.querySelectorAll(".l-header a, .l-header input, .l-header select");
    this.execTabActivate(gotoContents, activate);
    this.execTabActivate(_anchors, activate);
    this.execTabActivate(_buttons, activate);
    this.execTabActivate(_breadcrumbs, activate);
    this.execTabActivate(_footers, activate);
    if (useHeader) {
      this.execTabActivate(_header, activate);
    }
    if (activate) {
      this.execTabActivate(_header, activate);
    }
  }
  execTabActivate(targets, activate) {
    if (!targets) {
      return;
    }
    _each(targets, (elm, index) => {
      if (elm.classList.contains("js-notabindex")) {
        return;
      }
      if (activate) {
        elm.setAttribute("tabindex", null);
      } else {
        elm.setAttribute("tabindex", "-1");
      }
    });
  }

  queryString() {
    let hash = location.hash;
    if (hash) {
      return hash.replace("#", "");
    }
    return "";
  }

  async checkAuthorization () {
    if (window.customerLogin && window.enableCustomerLogin) {
      setTimeout(() => {
        this.dispatchLocksmithEvent('locksmith_access_granted', true);
      }, 100)

      return
    };
    
    const pageUrl = window.lockSmithRequestURL ? window.lockSmithRequestURL : '';
  
    if (!pageUrl) return;
    try {
      const response = await fetch(`/apps/locksmith/api/resources?urls=${encodeURIComponent(pageUrl)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const resources = await response.json();
      const accessGranted = resources[pageUrl]?.access_granted;

      console.log('resources[pageUrl].access_granted', resources[pageUrl].access_granted);

      const eventName = accessGranted ? 'locksmith_access_granted' : 'locksmith_no_access';
      
      this.dispatchLocksmithEvent(eventName, accessGranted);
    } catch (error) {
      console.error('Error fetching resources:', error);
      this.dispatchLocksmithEvent('locksmith_no_access', true);
    }
  }

  dispatchLocksmithEvent(eventName, accessGranted) {
    document.dispatchEvent(new CustomEvent(eventName, {
      detail: { access_granted: accessGranted }
    }));
  }
  
}

export default new Common();
